import type * as React from 'react';
import { get } from '@Domain/Api';
import auditOutcomesFetched, {
	type AuditOutcomesFetchedAction,
	type AuditOutcomesFetchedPayload,
} from '@Application/AuditTrail/Actions/auditOutcomesFetched';
import auditOutcomesFetchFailed, {
	type AuditOutcomesFetchFailedAction,
} from '@Application/AuditTrail/Actions/auditOutcomesFetchFailed';
import type FetchAuditOutcomes from '@Application/AuditTrail/Queries/FetchAuditOutcomes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AuditOutcomesFetchedAction | AuditOutcomesFetchFailedAction;

/** A referential list of outcomes: no tenant, no parameter. */
export default (_query: FetchAuditOutcomes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AuditOutcomesFetchedPayload>(
				`${parameters.api.host}/api/enums/audit-outcomes`,
			);

			const action = auditOutcomesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = auditOutcomesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
